import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function ViewPickup() {
   const navigate = useNavigate();
   const { id } = useParams();
   const [pickup, setPickup] = useState(null);

   useEffect(() => {
      const fetchPickup = async () => {
         try {
            const res = await axios.get(`/auth/redem-pickup-requests/${id}`);
            setPickup(res.data);
         } catch (err) {
            console.error("Error fetching pickup request:", err);
         }
      };
      fetchPickup();
   }, [id]);

   if (!pickup) {
      return <div className="p-6 text-gray-500 text-center">Loading pickup details...</div>;
   }

   return (
      <section className="px-4 sm:px-6 lg:px-8 py-8 bg-gray-50 min-h-screen">
         <div className="bg-white max-w-5xl mx-auto p-6 sm:p-10 rounded-2xl shadow-2xl">
            <h1 className="text-3xl font-extrabold text-center text-green-700 mb-10">
               Pickup Request Details
            </h1>

            <div className="grid gap-6">
               <div className="flex flex-col sm:flex-row sm:items-center gap-6 mb-3">
                  <div className="inline-block bg-green-100 text-green-700 font-semibold px-4 py-1 rounded-full text-sm shadow-sm">
                     {pickup.cust_id || `REQ-${pickup.id}`}
                  </div>
                  <div>
                     <h2 className="text-xl font-semibold text-green-800">Pickup Info</h2>
                     <p className="text-sm text-gray-500">View detailed pickup request information</p>
                  </div>
               </div>

               <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-4">
                  <Info label="First Name" value={pickup.first_name} />
                  <Info label="Last Name" value={pickup.last_name} />
                  <Info label="Email" value={pickup.email} />
                  <Info label="Phone" value={pickup.phone} />
                  <Info label="Country" value={pickup.country} />
                  <Info label="Street Address" value={pickup.street_address} />
                  <Info label="City" value={pickup.city} />
                  <Info label="State/Province" value={pickup.state} />
                  <Info label="Zip" value={pickup.zip} />
                  <Info label="Estimate Pickup Amount" value={pickup.estimated_bags} />
                  <Info
                     label="Pickup Date"
                     value={
                        pickup.pickup_date
                           ? new Date(pickup.pickup_date.split("T")[0] + "T00:00:00")
                              .toLocaleDateString("en-US", {
                                 year: "numeric",
                                 month: "long",
                                 day: "numeric",
                              })
                           : ""
                     }
                  />
                  <Info label="Pickup Time" value={pickup.pickup_time} />
                  <Info label="Assigned to" value={pickup.driver_assigned} />
                  <Info label="Instructions for Driver" value={pickup.driver_instructions} />
                  <Info label="Center Name" value={pickup.center_name} />
               </div>

               <div className="flex justify-end mt-5">
                  <button
                     onClick={() => navigate("/redem-pickuprequests")}
                     className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                  >
                     Back to List
                  </button>
               </div>
            </div>
         </div>
      </section>
   );
}

function Info({ label, value }) {
   return (
      <div className="text-gray-700">
         <span className="font-semibold">{label}:</span> {value || "-"}
      </div>
   );
}
